import { useState } from "react";
import { XIcon } from "@phosphor-icons/react";
import { INPUT_CLS } from "../crm/Form";

/**
 * Lightweight tag input — Enter or comma adds the current draft as a tag.
 * Backspace on empty input removes the last tag. Read-only mode hides the
 * input and shows a disabled list.
 */
export default function TagInput({
  value = [],
  onChange,
  placeholder,
  readOnly = false,
  testidPrefix = "tag",
}) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const t = (raw || "").trim();
    if (!t) return;
    if (value.some((v) => v.toLowerCase() === t.toLowerCase())) {
      setDraft("");
      return;
    }
    onChange([...value, t]);
    setDraft("");
  };

  const remove = (idx) => {
    const next = value.slice();
    next.splice(idx, 1);
    onChange(next);
  };

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && value.length > 0) {
      remove(value.length - 1);
    }
  };

  return (
    <div data-testid={`${testidPrefix}-input`}>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {value.length === 0 && (
          <span className="text-xs text-slate-400 italic">No entries</span>
        )}
        {value.map((tag, idx) => (
          <span
            key={`${tag}-${idx}`}
            data-testid={`${testidPrefix}-pill-${idx}`}
            className="inline-flex items-center gap-1 rounded-md border border-slate-300 bg-slate-100 px-2 py-0.5 text-xs text-slate-800"
          >
            {tag}
            {!readOnly && (
              <button
                type="button"
                onClick={() => remove(idx)}
                aria-label={`Remove ${tag}`}
                data-testid={`${testidPrefix}-remove-${idx}`}
                className="text-slate-500 hover:text-slate-900"
              >
                <XIcon size={12} />
              </button>
            )}
          </span>
        ))}
      </div>
      {!readOnly && (
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => draft.trim() && add(draft)}
          onKeyDown={onKey}
          placeholder={placeholder || "Type and press Enter…"}
          data-testid={`${testidPrefix}-text-input`}
          className={INPUT_CLS}
        />
      )}
    </div>
  );
}
